const fallbackImage = '/_next/static/media/logo.38f41455.png'; // Use local path

export const imageSrc = (url: string): string => {
  if (!url) return fallbackImage;

  // Already absolute URL
  if (/^https?:\/\//.test(url)) return url;

  // For relative paths, prepend base URL
  const base =
    process.env.NEXT_PUBLIC_BASE_URL || 'https://server.rehabsolutionsbd.com';
  return `${base}${url.startsWith('/') ? '' : '/'}${url}`;
};
